"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.dataCy = void 0;
var _MenuItem = _interopRequireDefault(require("../../MenuItem"));
var _Typography = _interopRequireDefault(require("../../Typography"));
var _Stack = _interopRequireDefault(require("../../Stack"));
var _Divider = _interopRequireDefault(require("../../Divider"));
var _react = require("react");
var _styles = require("@mui/styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["action"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var dataCy = exports.dataCy = 'Actions';
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    message: {
      padding: '4px 16px'
    },
    messageDivider: {
      margin: '8px 0'
    }
  };
});
var ActionMenuItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var action = _ref.action,
    props = _objectWithoutProperties(_ref, _excluded);
  var label = [action.label];
  var tooltipText = action.tooltip || action.label || '';
  var classes = useStyles();
  if (action.message) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      "data-cy-label": action.label,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
        className: classes.message,
        spacing: 0.5,
        direction: 'row',
        alignItems: 'center',
        children: [action.icon, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
          variant: 'caption',
          color: 'textSecondary',
          tooltipText: tooltipText,
          "data-cy-role": 'actionMessageText',
          children: action.label
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider["default"], {
        className: classes.messageDivider
      })]
    });
  }
  if (action.add) {
    label = [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      children: "Add "
    }, "add_label_key_".concat(action.id)), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      style: {
        textTransform: 'lowercase'
      },
      children: action.label
    }, "text_label_key_".concat(action.id))];
    tooltipText = "Add ".concat(tooltipText.toLowerCase());
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_MenuItem["default"], _objectSpread(_objectSpread({
    ref: ref,
    disabled: action.disabled,
    id: action.id,
    "data-cy-label": action.label,
    component: action.component,
    color: 'inherit',
    selected: action.selected
  }, props), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
      variant: 'inherit',
      noWrap: true,
      color: 'inherit',
      "data-cy-role": 'actionText',
      tooltipText: tooltipText,
      children: label
    })
  }));
});
var _default = exports["default"] = ActionMenuItem;